import {interfaceSchoolRepository} from "../../../infrastructure/repository/impl/school_repository";
import {School} from "../../entities/entities";

interface SchoolUseCases {
  get(schoolID: number): Promise<School>;
  list(): Promise<School[]>;
  listBySearch(search: string): Promise<School[]>;
}

class _SchoolUseCases implements SchoolUseCases {
  async get(schoolID: number): Promise<School> {
    return await interfaceSchoolRepository.get(schoolID);
  }

  async list(): Promise<School[]> {
    return await interfaceSchoolRepository.list();
  }

  async listBySearch(search: string): Promise<School[]> {
    return await interfaceSchoolRepository.listBySearch(search);
  }
}

export const InterfaceSchoolUseCases: SchoolUseCases = new _SchoolUseCases();
